































































































































































































































































































































































































































import Vue from "vue";
import FormSection from "@/components/FormSection.vue";
import store, { InterfaceStore } from "../../services/InterfaceStore";
import IconButton from "@/components/IconButton.vue";


interface Data {
  store: InterfaceStore;
}

interface Methods {
  saveremark(): Promise<void>;
}

interface Computed {
  locked: boolean;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  name: "SyncPartnerEdit",

  components: {
    FormSection,
    IconButton,
  },

  async beforeMount() {
    const id: number = Number(this.$route.params["id"]) || 0;
    await store.loadEditingPartner(id);
  },

  data() {
    return { store };
  },

  computed: {
    /** Csak a szinkron sor legutolsó köztes tábla sora szerkeszthető. */
    locked(): boolean {
      return !this.store.editingPartnerIsLatest || this.store.editorViewOnly;
    },
  },

  methods: {
    /**
     * Szinkron megjegyzés mentése — csak a sync_remark + upddate/updtime/upduser mezők
     * módosulnak az adott köztes tábla soron, a usermodified flag NEM változik.
     */
    async saveremark() {
      try {
        await this.store.saveEditingPartnerRemark();
      } catch (e) {
        console.error(e);
      }
    },
  },
});
